let key = {};
if (process.env.NODE_ENV === "production") {
  key = {
    txLink: {
      1: "https://etherscan.io/",
      56: "https://bscscan.com/",
      137: "https://polygonscan.com/",
      43114: "https://snowtrace.io/",
      250: "https://ftmscan.com/",
      42161: "https://arbiscan.io/",
      10: "https://optimistic.etherscan.io/",
      97: "https://testnet.bscscan.com/",
    },
    rpc: {
      97: "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
      1: "https://mainnet.infura.io/v3/d5b89bd22ca242798dd9feb0ab031ccf",
      56: "https://bsc-dataseed.binance.org/",
      137: "https://polygon-rpc.com/",

      43114: "https://api.avax.network/ext/bc/C/rpc",
      250: "https://rpcapi.fantom.network",
      42161: "https://endpoints.omniatech.io/v1/arbitrum/one/public",
      10: "https://mainnet.optimism.io",
      128: "https://http-mainnet-node.huobichain.com",
      8453: "https://mainnet.base.org",
    },
    defaultLogo: "https://dopaminedexapi.wealwindemo.com/tokens/default.png",
    imageUrl: "https://dopaminedexapi.wealwindemo.com/",
    baseUrl: "https://dopaminedexapi.wealwindemo.com/adminapi",
    p2pUrl: "http://localhost:2053",
    p2pimageUrl: "https://p2papi.inwdex.com/",
    farmImg: "https://dopaminedexapi.wealwindemo.com/farms/",
    gateway: "https://indxbuytokenapi.alwin.io/v2",
    loaderColor: "#0a0a3a",
    txUrl: "https://testnet.bscscan.com/tx/",
    factory: "0x60C793b4F4559f683FEd9d24F4DF56F0f8DfAb65",
    masterchef: "0x8F91A4a04A3Ef05782E99f43A07c226313a2948f",
    netWorkUrl: "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
    netWorkversion: 97,
    secretkey: "DOPE*26@7#$%@",
    wallet: {
      chainName: "Bsc test network",
      chainId: 97,
      name: "Bsc",
      symbol: "BNB", // 2-6 characters long
      decimals: 18,
      rpcUrls: ["https://data-seed-prebsc-2-s2.bnbchain.org:8545"],
    },
    cryptoSecretKey: "1234567812345678",
  };
} else {
  key = {
    txLink: {
      1: "https://etherscan.io/",
      56: "https://bscscan.com/",
      137: "https://polygonscan.com/",
      43114: "https://snowtrace.io/",
      250: "https://ftmscan.com/",
      42161: "https://arbiscan.io/",
      10: "https://optimistic.etherscan.io/",
      97: "https://testnet.bscscan.com/",
    },
    rpc: {
      97: "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
      1: "https://mainnet.infura.io/v3/d5b89bd22ca242798dd9feb0ab031ccf",
      56: "https://bsc-dataseed.binance.org/",
      137: "https://polygon-rpc.com/",

      43114: "https://api.avax.network/ext/bc/C/rpc",
      250: "https://rpcapi.fantom.network",
      42161: "https://endpoints.omniatech.io/v1/arbitrum/one/public",
      10: "https://mainnet.optimism.io",
      128: "https://http-mainnet-node.huobichain.com",
      8453: "https://mainnet.base.org",
    },
    defaultLogo: "https://dopaminedexapi.wealwindemo.com/tokens/default.png",
    imageUrl: "http://localhost:3533/",
    baseUrl: "http://localhost:3533/adminapi",
    // baseUrl: "https://dopaminedexapi.wealwindemo.com/adminapi",
    p2pUrl: "http://localhost:2053",
    p2pimageUrl: "https://p2papi.inwdex.com/",
    farmImg: "http://localhost:3533/farms/",
    gateway: "https://indxbuytokenapi.alwin.io/v2",
    loaderColor: "#0a0a3a",
    txUrl: "https://testnet.bscscan.com/tx/",
    factory: "0x60C793b4F4559f683FEd9d24F4DF56F0f8DfAb65",
    masterchef: "0x8F91A4a04A3Ef05782E99f43A07c226313a2948f",
    netWorkUrl: "https://data-seed-prebsc-2-s2.bnbchain.org:8545",
    netWorkversion: 97,
    secretkey: "DOPE*26@7#$%@",
    wallet: {
      chainName: "Bsc test network",
      chainId: 97,
      name: "Bsc",
      symbol: "BNB", // 2-6 characters long
      decimals: 18,
      rpcUrls: ["https://data-seed-prebsc-2-s2.bnbchain.org:8545"],
    },
    cryptoSecretKey: "1234567812345678",
  };
}

export default key;
